import { Controller } from "@hotwired/stimulus"
import { DirectUpload } from "@rails/activestorage"
import Dropzone from "dropzone"

Dropzone.autoDiscover = false

export default class extends Controller {
  static values = {
    url: { type: String, default: "/rails/active_storage/direct_uploads" },
    maxFileSize: { type: Number, default: 10 },
    acceptedFiles: { type: String, default: "image/png,image/jpeg,image/webp" },
    paramName: { type: String, default: "article[photos][]" }
  }

  connect() {
    this.dropzone = new Dropzone(this.element, {
      url: this.urlValue,
      autoProcessQueue: false,
      maxFilesize: this.maxFileSizeValue,
      acceptedFiles: this.acceptedFilesValue,
      addRemoveLinks: true,
      dictDefaultMessage: this.element.dataset.dictMessage || "Přetáhněte obrázky sem nebo klikněte pro výběr",
      dictRemoveFile: this.element.dataset.dictRemove || "Odebrat",
      headers: { "X-CSRF-Token": this._csrfToken() }
    })

    this.dropzone.on("addedfile", (file) => this._uploadFile(file))
    this.dropzone.on("removedfile", (file) => this._removeHiddenInput(file))
  }

  disconnect() {
    if (this.dropzone) this.dropzone.destroy()
  }

  _uploadFile(file) {
    const delegate = {
      directUploadWillStoreFileWithXHR: (request) => {
        request.upload.addEventListener("progress", (event) => {
          const progress = (event.loaded / event.total) * 100
          file.upload.progress = progress
          this.dropzone.emit("uploadprogress", file, progress, event.loaded)
        })
      }
    }

    const upload = new DirectUpload(file, this.urlValue, delegate)

    upload.create((error, blob) => {
      if (error) {
        file.previewElement.classList.add("dz-error")
        const errorMsg = file.previewElement.querySelector("[data-dz-errormessage]")
        if (errorMsg) errorMsg.textContent = error
        return
      }

      file.previewElement.classList.add("dz-success", "dz-complete")
      file.signedId = blob.signed_id
      file.status = Dropzone.SUCCESS
      this.dropzone.emit("success", file)
      this.dropzone.emit("complete", file)

      const input = document.createElement("input")
      input.type = "hidden"
      input.name = this.paramNameValue
      input.value = blob.signed_id
      input.dataset.dropzoneFile = file.upload.uuid
      this._form().appendChild(input)
    })
  }

  _removeHiddenInput(file) {
    const input = this._form().querySelector(`input[data-dropzone-file="${file.upload.uuid}"]`)
    if (input) input.remove()
  }

  _form() {
    return this.element.closest("form")
  }

  _csrfToken() {
    const meta = document.querySelector('meta[name="csrf-token"]')
    return meta ? meta.content : ""
  }
}
